/**
 * A compact "!" indicator that reveals its (often multi-line SQL) error on
 * hover or keyboard focus. Used where the full error doesn't fit inline — e.g.
 * a metric card. The message is also on `aria-label` so screen readers get it
 * without the hover.
 */
export function ErrorBadge({ message }: { message: string }) {
  return (
    <span
      className="dw-error-badge"
      tabIndex={0}
      aria-label={`Error: ${message}`}
    >
      !
      <span className="dw-error-tip" role="tooltip">
        {message}
      </span>
    </span>
  );
}
